export default __webpack_public_path__ + "static/media/logo-sportmadness.4f849f00.png";